/** @format */

import React, {
  useContext,
  useReducer,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { useRouter } from "next/router";
import axios from "axios";

import { pageUrl, requestData } from "@utils/product";
import { reducer } from "@reducers/product/list";
import { api } from "@utils/api";

const MasterAttributeContext = React.createContext();
export const MasterAttributeProvider = ({ children, props }) => {
  const [state, dispatch] = useReducer(reducer, {
    filters: [],
    options: [],
    loading: true,
  });
  const router = useRouter();
  const req = useRef(null);

  const loadOptions = useCallback(async () => {
    if (req.current) {
      req.current.cancel();
    }
    req.current = axios.CancelToken.source();
    let masIds = {};
    let ops = state.filters.filter((i) => i.type === "options");
    for (let i = 0; i < ops.length; i++) {
      const op = ops[i];
      if (masIds[op.masId]) {
        masIds[op.masId][op._id] = true;
      } else {
        masIds[op.masId] = { [op._id]: true };
      }
    }

    const data = {
      ...requestData({
        filters: {
          brand: props.filters.brand,
          category: props.filters.category,
          retailer: props.filters.retailer,
          options: props.filters.options,
          name: props.filters.name,

          price_from: props.filters.price_from,

          price_to: props.filters.price_to,
          shipping: props.filters.shipping,
        },
        category: props.category,
        retailerId: props.retailerId,
        brand: props.brand,
      }).filter,
      category: props.category,
      masIds,
    };

    // if (props.filters.category) {
    // 	data.categories.push(props.category);
    // }

    const { cancelled, options } = await api({
      url: "/product/more-filters",
      method: "POST",
      cancelToken: req.current.token,
      data,
    });

    if (cancelled) {
      return false;
    }

    let filters = [];
    if (props.filters.options) {
      let selected = props.filters.options.split("|").join("||").split("||");
      for (let i = 0; i < options.length; i++) {
        for (let j = 0; j < options[i].options.length; j++) {
          const op = options[i].options[j];
          if (selected.indexOf(op.attrVal.toString()) !== -1) {
            filters.push({
              _id: op.attrVal,
              label: options[i].type === "visual" ? op.title : op.value,
              masId: options[i]._id,
              type: "options",
            });
          }
        }
      }
    }

    dispatch({
      type: "SET_DATA",
      data: {
        filters,
        options,
        loading: false,
      },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.category,
    props.brand,
    props.retailerId,
    props.filters.brand,
    props.filters.category,
    props.filters.retailer,
    props.filters.options,
    props.filters.price_from,
    props.filters.price_to,
    props.filters.shipping,
  ]);

  useEffect(() => {
    if (!props.isAuction) loadOptions();

    return () => {
      if (req.current) {
        req.current.cancel();
        req.current = null;
      }
    };
  }, [loadOptions, props.isAuction]);

  const updateFilter = (filters, push = false) => {
    dispatch({
      type: "SET_DATA",
      data: {
        filters,
      },
    });

    if (push) {
      let opIds = {};
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];
        if (opIds[filter.masId]) {
          opIds[filter.masId].push(filter._id);
        } else {
          opIds[filter.masId] = [filter._id];
        }
      }

      let query = props.filters;

      if (Object.keys(opIds).length) {
        query.options = Object.keys(opIds)
          .map((i) => opIds[i].join("|"))
          .join("||");
      } else {
        delete query.options;
      }

      delete query.page;

      router.push({
        pathname: pageUrl(props),
        query,
      });
    }
  };

  return (
    <MasterAttributeContext.Provider
      value={{
        options: state.options,
        filters: state.filters,
        loading: state.loading,
        updateFilter,
      }}
    >
      {children}
    </MasterAttributeContext.Provider>
  );
};

export function useMasterAttribute() {
  const context = useContext(MasterAttributeContext);
  if (context === undefined) {
    throw new Error(
      "useMasterAttribute must be used within a MasterAttributeProvider"
    );
  }
  return context;
}
